import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';

const FOOTER_OFFSET = 400;

@Component({
    selector: 'scroll-container',
    templateUrl: './scroll-container.component.html',
    styles: ['.loader-container { height: 50px; width: 50px; margin: 10px auto} ',
        '.loader-text {display: block; text-align: center; margin-bottom: 20px; font-size: 12px}']
})
export class ScrollContainerComponent {
    private emittingEvent = false;
    @Output() endOfContent = new EventEmitter<void>();

    @Input() loading = false;

    @Input() reloading = false;

    @Input() initializing = false;

    @Input() loadingText = 'Loading more...';

    @Input() reloadingText = '';

    @HostListener('window:scroll')
    onWindowScroll() {
        this.checkScroll();
    }

    @HostListener('touchend', ['$event'])
    @HostListener('touchcancel', ['$event'])
    onTouchMove() {
        this.checkScroll();
    }

    @HostListener('window:resize')
    onWindowResize() {
        this.checkScroll();
    }


    private checkScroll() {
        if (this.loading || this.initializing) {
            return;
        }

        if (this.emittingEvent) {
            return;
        }
        if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight - FOOTER_OFFSET) {
            this.emittingEvent = true;
            this.endOfContent.emit();
            // need some timout to avoid sending multiple events
            setTimeout(() => {
                this.emittingEvent = false;
            }, 1000);

        }
    }

}
